//@author: travis
import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    Input,
    NgZone,
    OnInit,
    ViewEncapsulation,
} from "@angular/core";
import { S25DropdownAbstract } from "../s25.dropdown.abstract";
import { SearchCriteriaService } from "../../../services/search/search-criteria/search.criteria.service";
import { S25Util } from "../../../util/s25-util";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { DropdownDataUtil } from "../dropdown.data.util";

@TypeManagerDecorator("s25-resource-dropdown")
@Component({
    selector: "s25-resource-dropdown",
    template: `
        @if (items) {
            <s25-generic-dropdown
                [value]="value()"
                [hasFav]="true"
                [onSelect]="onSelect"
                [items]="items"
                [staticItems]="staticItems"
                [autoOpen]="autoOpen"
                [alwaysOpen]="alwaysOpen"
                [hideSearch]="hideSearch"
                [focusFirst]="false"
                [searchEnabled]="true"
                [apiBean]="apiBean"
                [serverSide]="serverSide"
                [placeholder]="'Select a Resource'"
                [resetSelectedOnCleanup]="resetSelectedOnCleanup"
                [blockDetailsNav]="blockDetailsNav"
                (valueChange)="onValueChange($event)"
            />
        }
    `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class S25ResourceDropdownComponent extends S25DropdownAbstract implements OnInit {
    @Input() customFilterValue: string;

    constructor(
        private zone: NgZone,
        private elementRef: ElementRef,
    ) {
        super();
    }

    ngOnInit() {
        const value = this.value();
        if (value) {
            value.itemTypeId = 6;
        }
        SearchCriteriaService.getResources(-999, 0, 999, null, true, null, this.customFilterValue).then((data) => {
            this.zone.run(() => {
                this.staticItems = (data && data.searchCriteria && data.searchCriteria.item) || [];
                this.serverSide = DropdownDataUtil.getServerSideModel(
                    "getResources",
                    this.elementRef.nativeElement,
                    this.customFilterValue,
                );
                this.items = S25Util.deepCopy(this.staticItems);
                this.onLoad && this.onLoad();
            });
        });
    }
}
